import { Link } from "react-router-dom";
import { Mail, Leaf, ArrowUpRight, Zap } from "lucide-react";
import { LANDING } from "@/constants/testIds";

export default function Footer() {
  return (
    <footer className="relative bg-[#061414] text-white pt-16 pb-10 overflow-hidden">
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 mb-6">
              <span className="grid place-items-center w-8 h-8 rounded-md text-white" style={{ background: "linear-gradient(135deg, #10B981, #059669)" }}>
                <Leaf size={16} strokeWidth={2.5} />
              </span>
              <div className="font-display font-extrabold tracking-tight text-xl">
                Bandofotovoltaico<span className="text-emerald-400">24</span>
              </div>
            </div>
            <p className="text-white/60 text-sm max-w-md leading-relaxed">
              Analizziamo preventivi fotovoltaici e simuliamo configurazioni per privati e aziende. Valutazione gratuita e indicazioni costruite sul singolo caso, senza impegno.
            </p>
            <a
              href="mailto:info@bandofotovoltaico24.it"
              data-testid={LANDING.emailContatto}
              className="mt-8 inline-flex flex-wrap items-center gap-2 text-base sm:text-lg font-display font-medium group"
            >
              <Mail size={20} className="text-emerald-400" />
              <span className="break-all">info@bandofotovoltaico24.it</span>
              <ArrowUpRight size={18} className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
            </a>
          </div>

          <div className="md:col-span-3">
            <div className="overline text-white/70 mb-4">Naviga</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-emerald-400 transition-colors">Home</Link></li>
              <li><Link to="/analisi-preventivo" className="hover:text-emerald-400 transition-colors">Analisi preventivo</Link></li>
              <li><Link to="/#privati" className="hover:text-emerald-400 transition-colors">Per Privati</Link></li>
              <li><Link to="/#aziende" className="hover:text-emerald-400 transition-colors">Per Aziende</Link></li>
              <li><Link to="/configuratore" className="hover:text-emerald-400 transition-colors">Configuratore</Link></li>
              <li><Link to="/#guide" className="hover:text-emerald-400 transition-colors">Guide PDF</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="overline text-white/70 mb-4">Legale</div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/privacy" className="hover:text-emerald-400 transition-colors">Informativa Privacy (GDPR)</Link></li>
              <li><Link to="/cookie" className="hover:text-emerald-400 transition-colors">Cookie Policy</Link></li>
              <li className="text-white/70 flex items-center gap-1.5"><Zap size={12} className="text-emerald-400" /> Servizio attivo in tutta Italia</li>
              <li><Link to="/admin/login" className="text-white/70 text-xs hover:text-white/60">Area Admin</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/15 pt-6 pb-6 text-sm text-white/75 leading-relaxed">
          <p className="font-medium text-white">Servizio di consulenza di Valerio Testi</p>
          <p>P. IVA 03045360348 · Via Bastelli 8, 43036 Fidenza (PR)</p>
          <p className="mt-2">Bandofotovoltaico24 è un servizio privato: non è un ente pubblico e non assegna contributi.</p>
        </div>
        <div className="hairline border-white/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-white/70">
          <div>© {new Date().getFullYear()} Bandofotovoltaico24 — Tutti i diritti riservati.</div>
          <div>Finalità del trattamento e diritti: consulta l’informativa privacy.</div>
        </div>
      </div>
    </footer>
  );
}
